import { render, staticRenderFns } from "./checkOrderDetails.vue?vue&type=template&id=1b28aed4&scoped=true&"
import script from "./checkOrderDetails.vue?vue&type=script&lang=js&"
export * from "./checkOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./checkOrderDetails.vue?vue&type=style&index=0&id=1b28aed4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b28aed4",
  null
  
)

component.options.__file = "checkOrderDetails.vue"
export default component.exports